import React, { useEffect } from "react";
import Homepage from "./Application/Homepage";
import Banner from "./Application/Banner";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
function App() {
  // Cette partie sert à récupérer l'email donné en paramètres dans l'URL, et l'enregistre dans localStorage.
  const [searchParams] = useSearchParams();
  const savedEmail = localStorage.getItem("email");
  const mail = searchParams.get("email");

  const [email, setEmail] = useState(
    savedEmail ? JSON.parse(savedEmail) : [searchParams.get("email")]
  );
  mail !== email && setEmail(mail);
  useEffect(
    () => localStorage.setItem("email", JSON.stringify(email)),
    [email]
  );

  return (
    <div>
      <Banner />
      <Homepage email={email} />
    </div>
  );
}

export default App;
